import {Box, Link, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {Row} from 'presentation/components';
import {ProfileEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatMasks} from 'presentation/utils';
import {ControlledCheckbox} from '../ControlledCheckbox';
import {StyledBox, StyledStack} from './styles';
import {ContactInfoProps} from './types';

const {
	title,
	cellphone,
	cellphoneEmpty,
	emailEmpty,
	email,
	goToProfile,
	goToPofileMessage,
	whatsappUpdates,
} = translations['pt-br'].privateFlow.contactInfo;

const ContactInfo = ({
	user,
	hideBottomNav,
	hideEmail,
	showCheckbox,
	checked,
	handleCheck,
	dataTagId,
}: ContactInfoProps) => {
	const navigate = useNavigate();
	const {pathname} = useLocation();
	const {isTablet} = useMediaQueries();
	const {colors} = useTheme();
	const emailValue = user?.email ? user.email : emailEmpty;
	const cellphoneValue = user?.cellphone ? formatMasks('phone', user.cellphone) : cellphoneEmpty;

	const handleNavToProfile = () => {
		navigate(ProfileEnum.PROFILE, {state: pathname});
	};

	return (
		<StyledBox>
			<Stack spacing={2} sx={{p: 2}}>
				<Typography variant="subtitle2" color="text.secondary">
					{title}
				</Typography>

				<Stack direction={isTablet ? 'column' : 'row'} spacing={isTablet ? 2 : 0}>
					<Box width={isTablet ? '100%' : '50%'}>
						<Row.Simple
							title={cellphone}
							value={cellphoneValue}
							hiddenDivider={!isTablet}
							color={user.cellphone ? 'text.primary' : 'text.secondary'}
						/>
					</Box>
					{!hideEmail ? (
						<Row.Simple
							title={email}
							value={emailValue}
							hiddenDivider
							color={user.email ? 'text.primary' : 'text.secondary'}
						/>
					) : null}
				</Stack>
			</Stack>

			{showCheckbox ? (
				<Stack px={2} py={1} borderTop={`0.5px solid ${colors.gray['40Percent']}`}>
					<ControlledCheckbox
						checked={checked}
						handleCheck={handleCheck}
						label={whatsappUpdates}
					/>
				</Stack>
			) : null}

			{!hideBottomNav ? (
				<StyledStack>
					<Typography variant="caption" color="text.secondary">
						{goToPofileMessage}
					</Typography>
					<Link
						data-tag-id={dataTagId}
						onClick={handleNavToProfile}
						variant="body2"
						color="primary.main"
						sx={{cursor: 'pointer', fontSize: 12}}>
						{goToProfile}
					</Link>
				</StyledStack>
			) : null}
		</StyledBox>
	);
};

export {ContactInfo};
